import {useGameStore} from '../GameStoreContext'

export const useIsReplay = () => {
    const isReplay = useGameStore((state) => state.gameReplay.isReplay)
    return isReplay
}
